export default {
  dynamics: '{{change}} ift. forrige uge',
};
